import React from "react";
import { post } from "../fetchData";

const useFetchAccounts = () => {
  const [accounts, setAccounts] = React.useState<any>([]);
  const [loading, setLoading] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    listAccounts();
  }, []);

  const listAccounts = () => {
    setLoading(true);
    setLoaded(false);
 post( { },"list_accounts" )
      .then(
        (result) => {
          setLoading(false);
          console.log(result);
            setAccounts(result?.status ? result.data : []);
        },
        (error) => {
          setAccounts([]);
        }
      )
      .finally(() => {
        setLoading(false);
        setLoaded(false);
      }); //fetch
  }; //doAjax

  return {accounts,loading,loaded};
};

export default useFetchAccounts;
